module.exports = __webpack_public_path__ + "BebasNeue-webfont.ace28fcc6f8a1a8517a3.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/assets/fonts/BebasNeue-webfont.ttf
// module id = ../../../../../src/assets/fonts/BebasNeue-webfont.ttf
// module chunks = styles